module.exports = __webpack_public_path__ + "img/bg3.1c7c2b2.png";